import actions from './actions'
import { getDefaultRoutes } from 'services/router'
import { MenuState, MenuAction } from './types'

const initialState: MenuState = {
  initialized: window.parent !== window,
  menuData: [],
  routerData: getDefaultRoutes(),
  configData: {},
  popups: {},
}

export default function menuReducer(
  state: MenuState = initialState,
  action: MenuAction,
): MenuState {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    case actions.SET_POPUP: {
      const newState = { ...state }
      newState.popups = { ...newState.popups, ...action.payload }
      return { ...newState }
    }
    default:
      return state
  }
}
